import { ObjectDataset } from "@tblabs/storage";
import { ApplyForm } from "../Models/ApplyForm";
import { Repo } from "../Services/Repo";


export class ApplysRepo extends Repo<ApplyForm>
{
    constructor(_repo: ObjectDataset<ApplyForm>)
    {
        super(_repo);
    }
}
